<template>
  <div class="userInfo">
    <div class="operateClass">
      <el-button type="primary" plain @click="seeHelp">查看帮助</el-button>
    </div>
    <el-form :model="form" :rules="rules" ref="ruleForm" label-position="left" label-width="150px" class="userFrom">
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="最终客户单位名称：" prop="customName">
            <el-input v-model="form.customName" maxlength="100" class="itemClass" placeholder="请输入最终客户单位名称"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="单位名称：" prop="applicantCompanyName">
            <el-input v-model="form.applicantCompanyName" maxlength="100" class="itemClass" placeholder="请输入单位名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="联系人姓名：" prop="applicantName">
            <el-input v-model="form.applicantName" maxlength="100" class="itemClass" placeholder="请输入联系人姓名"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="联系人电话：" prop="applicantPhone">
            <el-input v-model="form.applicantPhone" class="itemClass" placeholder="请输入联系人电话"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="联系人E-mail：" prop="applicantEmail" class="applicantEmail">
            <el-tooltip class="item" effect="dark" :arrowOffset="17" content="此邮箱用户接收激活结果，请确认邮箱地址有效" placement="top-start">
              <el-input v-model="form.applicantEmail" maxlength="100" class="itemClass" placeholder="请输入联系人E-mail"></el-input>
            </el-tooltip>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="联系人邮编：" prop="applicantPostCode">
            <el-input v-model="form.applicantPostCode" maxlength="10" class="itemClass" placeholder="请输入联系人邮编"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row type="flex" justify="space-around">
        <el-col :span="9">
          <el-form-item label="联系人地址：" prop="applicantAddress">
            <el-input v-model="form.applicantAddress" maxlength="300" class="itemClass" placeholder="请输入联系人地址"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="9">
          <el-form-item label="项目名称：" prop="projectName">
            <el-input v-model="form.projectName" maxlength="100" class="itemClass" placeholder="请输入项目名称"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
import { checkForm } from "~/util/commonUtil";
import { mapState } from "vuex";
import requestActiveLicense from '~/request/requestActiveLicense';
export default {
  data(){
    return{
      form:{
        customName: '',
        applicantCompanyName: '',
        applicantName: '',
        applicantPhone: '',
        applicantEmail: '',
        applicantPostCode: '',
        applicantAddress: '',
        projectName: '',
      },
      rules:{
        customName:[
          { required: true, message: '请输入最终客户单位名称', trigger: ['blur', 'change'] }
        ],
        applicantCompanyName:[
          { required: true, message: '请输入单位名称', trigger: ['blur', 'change'] }
        ],
        applicantName:[
          { required: true, message: '请输入联系人姓名', trigger: ['blur', 'change'] }
        ],
        applicantPhone:[
          { required: true, message: '请输入联系人电话', trigger: ['blur', 'change'] },
          { pattern: /^[0-9-()]{1,20}$/, message: '请输入正确的联系人电话', trigger: ['blur', 'change'] }
        ],
        applicantEmail:[
          { required: true, message: '请输入联系人E-mail', trigger: ['blur', 'change'] },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        applicantPostCode:[
          { pattern: /^[0-9]*$/, message: '请输入正确的邮编', trigger: ['blur', 'change'] }
        ],
      },
    }
  },
  computed:{
    ...mapState(['processId'])
  },
  created(){
    requestActiveLicense.getUserInfo({'processId': this.processId}).then(res=>{
      if (res.code == '0') {
        console.log('res===', res);
        if(res && res.res && res.res.customName){
          Object.assign(this.form, res.res);
        }
      }
    }).catch(err =>{})
  },
  methods:{
    seeHelp(){
      window.open(`${location.origin}/document/license_activation_step3.html`);
    },
    getVail(){
      return checkForm('ruleForm', this);
    },
    getData(){
      return this.form;
    }
  }
}
</script>
<style lang="less" scoped>
.userInfo{
  .operateClass{
    text-align: right;
    margin-bottom: 16px;
  }
  .userFrom{
    .el-form-item{
      margin-bottom: 32px;
    }
    .applicantEmail{
      margin-bottom: 15px;
      .tip{
        font-size: 10px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #333333;
        height: 17px;
        line-height: 17px;
      }
    }
  }
  /deep/ .el-form-item__label,.el-input__inner {
    color: #333333 !important;
  }
}
</style>